import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async requestCredits ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/creditrequests', options)).data
      return response
    },

    async getCreditRequests ({ }, options) {
      let reqs = (await Vue.http.get(this.state.baseUrl + '/creditrequests/nurse?pageSize=' + (options.pageSize || 10) + '&pageNumber=' + options.pageNumber)).data
      return reqs
    },

    async getOnlineCreditTransactions ({ }, options) {
      let res = (await Vue.http.get(this.state.baseUrl + '/transaction/creditpointsrefill?pageSize=' + (options.pageSize || 10) + '&pageNumber=' + options.pageNumber)).data
      return res
    },
  }
}
